<template>
        <section class="user_section">
            <UserLnb :navTitle="navTitle" :bgStyle="'type2'" />
            <div class="title jc">
                <h2>오시는 길</h2>
            </div>
                                  
            <article class="view intro">
                <div>
                    <div class="map_area">
                        <div id="map" style="width:100%;height:400px;"></div>
                    </div>
                    <div class="search_box mt10">
                        <p>서울시 강서구 화곡로63길 93 신송타워 201호</p>
                        <div class="form_inline">
                            <button class="btn btn_md btn_brown" 
                                @click="openWindow"
                            >
                            지도에서 보기
                            </button>
                        </div>
                    </div>
                    <ul class="intro_list">
                        <li>
                            <h6>오시는 길</h6>
                            <div class="con_box">
                                <p>[버스로 오시는 방법]</p>
                                <p>
                                    KBS스포츠월드 정거장에서 내리신 후  <br> 
                                    등촌3동 주민센터쪽으로 도보로 5분정도 거리에 위치하고 있습니다. <br>
                                </p>
                            </div>
                        </li>
                        <li>
                            <h6></h6>
                            <div class="con_box">
                                <div class="box">
                                    <span>평일</span>
                                    <div class="info_box">
                                        <p>09:00 ~ 18:00</p>
                                        <p>점심시간 오후1시 ~ 오후2시</p>
                                    </div>
                                </div>
                                <div class="box">
                                    <span>주말</span>
                                    <div class="info_box">
                                        <p>09:00 ~ 14:00</p>
                                        <p>주말(토/일)은 점심시간 없이 오후 2시까지 진료</p>
                                    </div>
                                </div>
                                <div class="box">
                                    <span>공휴일</span>
                                    <div class="info_box">
                                        <p>09:00 ~ 14:00</p>
                                        <p>공휴일은 점심시간 없이 오후 2시까치 진료</p>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <h6>전화번호</h6>
                            <div class="con_box">
                                <a href="tel:02-6952-1514">02-6952-1514</a>
                            </div>
                        </li>                        
                        <li>
                            <h6>사업자정보</h6>
                            <div class="con_box">
                                <div class="box">
                                    <span>상호명</span>
                                    <div class="info_box">
                                        코끼리원외탕전
                                    </div>
                                </div>
                                <div class="box">
                                    <span>대표자</span>
                                    <div class="info_box">
                                        안가청
                                    </div>
                                </div>
                                <div class="box">
                                    <span>사업자번호</span>
                                    <div class="info_box">
                                       169-94-01307
                                    </div>
                                </div>
                                <div class="box">
                                    <span>이메일</span>
                                    <div class="info_box">
                                       uratcha88@naver.com
                                    </div>
                                </div>
                            </div>
                        </li>                                              
                    </ul>              
                </div>
            </article>
                       
        </section>
</template>
<script>

    export default {
        components: {
        },
        watch: {

        },
        mounted() {
            if (window.kakao && window.kakao.maps) {
                this.initMap()
            } else {
            const script = document.createElement("script");
                /* global kakao */
                script.onload = () => kakao.maps.load(this.initMap);
                script.src ="//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=138b055018863d42ebfb69a399b8b116";
                document.head.appendChild(script);
            }
        },
        methods: {
            initMap () {
                const container = document.getElementById("map");
                const options = {
                    center: new kakao.maps.LatLng(37.552060261462984, 126.91263978816121),
                    level: 1,
                }
                this.map = new kakao.maps.Map(container, options)
                this.initMarker()
            },
            initMarker () {
                const marker = new kakao.maps.Marker({
                    position: this.map.getCenter()
                })
                marker.setMap(this.map)
            },   
            openWindow () {
                window.open('https://map.kakao.com/?q=%EC%9C%BC%EB%9E%8F%EC%B0%A8%EC%B0%A8%ED%95%9C%EC%9D%98%EC%9B%90')
            }
        },
        data () {
            return {
                currentMenu: 0,
                navTitle: ['탕전실 소개', '오시는 길'],
                map: null
            }
        }
    }
</script>